import React from 'react'

const Help = () => {
  React.useEffect(() => {
    window.scrollTo(0, 0)
  },[])
  return (
    <div className='app'>Help</div>
  )
}

export default Help